export default "__VITE_ASSET__2ed4bea0__"